define('presentation/error/viewModels/errorViewModel',[], function () {
    return function () {
        var self = this;
        
    };
});
